import type {
  PostDriverRankTierConfigAdminRequest,
  PutDriverRankTierConfigAdminRequest
} from '@/backend/market'
import type { CreateUpdateDriverRankTierConfigEntity } from '../../domain/entities/CreateUpdateDriverRankTierConfigEntity'

export class CreateUpdateDriverRankTierConfigModel
  implements PostDriverRankTierConfigAdminRequest, PutDriverRankTierConfigAdminRequest
{
  regionId: number
  name: string
  sortOrder: number
  percentage: number
  minRiders?: number | null
  maxRiders?: number | null
  minTotalWorkingHours?: number
  minOrders?: number
  minEffectiveDays?: number
  isActive?: boolean
  driverEarningSetting?:
    | PostDriverRankTierConfigAdminRequest['driverEarningSetting']
    | PutDriverRankTierConfigAdminRequest['driverEarningSetting']

  constructor(data: CreateUpdateDriverRankTierConfigEntity) {
    this.regionId = data.region?.id ?? 0
    this.name = data.name ?? ''
    this.sortOrder = data.sortOrder ?? 0
    this.percentage = data.percentage ?? 0
    this.minRiders = data.minRiders
    this.maxRiders = data.maxRiders
    this.minTotalWorkingHours = data.minTotalWorkingHours
    this.minOrders = data.minOrders
    this.minEffectiveDays = data.minEffectiveDays
    this.isActive = data.isActive
    this.driverEarningSetting = data.driverEarningSetting
      ? {
          applyAdditionalFeeToAllRegionTiers:
            data.driverEarningSetting.applyAdditionalFeeToAllRegionTiers,
          vehicleDistanceRates:
            data.driverEarningSetting.vehicleDistanceRates?.map((item) => ({
              vehicleTemplateId: item.vehicleTemplateId,
              pickupFee: item.pickupFee,
              dropoffFee: item.dropoffFee,
              additionalFee: item.additionalFee,
              distanceFeePerKm: item.distanceFeePerKm
            })) ?? []
        }
      : undefined
  }
}
